import config from "config";

export default [
  '$q',
  '$cookies',
  'AuthService',
  'md5',
  class UserDataService {
    constructor($q, $cookies, AuthService, md5) {
      this._$q = $q;
      this._$cookies = $cookies;
      this._authService = AuthService;
      this._md5 = md5;
      this.user = null;
    }

    setUserData(res, setJwtCookie = false) {
      if (res && res.user) {
        this.user = res.user;
        this._storeLogin(res, setJwtCookie);
      } else {
        this.user = res;
        this._clearLogin();
      }
    }

    clearUserData() {
      this.user = null;
      this._clearLogin();
    }

    getUserData() {
      let promise;
      let defer = this._$q.defer();

      if (this.user) {
        promise = defer.promise;
        defer.resolve({
          user: this.user
        });
      } else {
        if (this.userLoggedIn()) {
          promise = this._authService.getCurrentUser();
        } else {
          promise = defer.promise;
          defer.reject();
        }
      }
      return promise;
    }

    isInAdminRole() {
      if (this.user && this.user.is_internal) {
        return true;
      }
      return false;
    }

    userLoggedIn() {
      return this._$cookies.get('login');
    }

    _storeLogin(res, setJwtCookie) {
      if (res.user && typeof res.user.email === 'string') {
        this._$cookies.put('login', true);
      }

      if (setJwtCookie) {
        this._$cookies.put('client-jwt', res.jwt, { domain: `.${config.DOMAIN}` });
      }

      return res;
    }

    _clearLogin() {
      this._$cookies.remove('login');
      this._$cookies.remove('client-jwt', { domain: `.${config.DOMAIN}` });
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/data-providers/user-data-service.js